import { render, staticRenderFns } from "./EditSubAsset.vue?vue&type=template&id=6c4d89f9"
import script from "./EditSubAsset.vue?vue&type=script&lang=ts"
export * from "./EditSubAsset.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports